module.exports = __webpack_public_path__ + "7326398608643083df7bef7d05f6b714.svg";